import { z } from "zod";

import { clampedLimit } from "./common.schema";
import { roleTypes } from "./contact.schema";

// === Account Contact Rollup (list view row) ===

export const AccountContactRollupSchema = z.object({
  contact_id: z.string().uuid().describe("Contact ID"),
  first_name: z.string().nullable().describe("First Name"),
  last_name: z.string().nullable().describe("Last Name"),
  email: z.string().nullable().describe("Email"),
  phone: z.string().nullable().describe("Phone"),
  company_name: z.string().nullable().describe("Company"),
  contact_created_at: z.string().describe("Contact Created At"),
  account_id: z.string().uuid().describe("Account"),
  is_primary_account: z.boolean().describe("Primary Account"),
  matched_at: z.string().nullable().describe("Matched At"),
  business_count: z.number().int().describe("Business Count"),
  role_types: z.array(z.string()).describe("Role Types"),
  business_names: z.array(z.string()).describe("Business Names"),
  latest_role_at: z.string().nullable().describe("Latest Role At"),
});
export type AccountContactRollup = z.infer<typeof AccountContactRollupSchema>;

// === Per-business role row on the detail page ===

export const AccountContactDetailRoleSchema = z.object({
  contact_role_id: z.string().uuid().describe("Role ID"),
  business_id: z.string().uuid().describe("Business ID"),
  business_name: z.string().describe("Business Name"),
  role_type: z.enum(roleTypes).describe("Role Type"),
  is_active: z.boolean().describe("Active"),
  role_created_at: z.string().describe("Role Created At"),
});
export type AccountContactDetailRole = z.infer<
  typeof AccountContactDetailRoleSchema
>;

// === Account Contact Detail (rollup + per-business roles) ===

export const AccountContactDetailSchema = AccountContactRollupSchema.extend({
  roles: z.array(AccountContactDetailRoleSchema).describe("Roles"),
});
export type AccountContactDetail = z.infer<typeof AccountContactDetailSchema>;

// === Query schema for list endpoint ===

export const AccountContactsQuerySchema = z.object({
  search: z.string().optional().describe("Search"),
  // schema-check-ignore: query-filter — null/"" semantically distinct from "no filter applied"
  role_type: z.enum(roleTypes).optional().describe("Role Type"),
  limit: clampedLimit(200, 50).describe("Limit"),
  offset: z.coerce.number().int().min(0).default(0).describe("Offset"),
  sort_by: z
    .enum([
      "last_name",
      "first_name",
      "email",
      "business_count",
      "latest_role_at",
      "matched_at",
    ])
    .default("last_name")
    .describe("Sort By"),
  sort_order: z.enum(["asc", "desc"]).default("asc").describe("Sort Order"),
});
export type AccountContactsQuery = z.infer<typeof AccountContactsQuerySchema>;
